<template>
    <v-main class="promoter-payout-list-page">
        <v-app-bar app flat light color="white">
            <AppbarBackIcon />
            <v-toolbar-title class="font-weight-bold">
                <span>提现记录</span>
            </v-toolbar-title>
        </v-app-bar>
        <v-container fluid class="content">
            <template v-if="showFilter">
                <v-row dense>
                    <v-col cols="5">
                        <v-select label="状态" v-model="form.status" :items="payoutStatusOptionList" />
                    </v-col>
                    <v-col cols="7">
                        <v-text-field label="在此日期之前" v-model="form.dt_created__lte"></v-text-field>
                    </v-col>
                </v-row>
                <div class="d-flex justify-center">
                    <v-btn class="mt-4 mb-4" color="primary" :width="128" @click="onQuery">查询</v-btn>
                </div>
            </template>
            <template v-else>
                <div class="section-header">
                    <div class="header-row" v-if="promoter_customer_id">
                        <span class="header-label">推广员ID:</span>
                        <span class="header-value">{{ promoter_customer_id }}</span>
                    </div>
                </div>
            </template>
            <div v-if="isEmpty" class="mt-4">无提现记录</div>
            <v-expansion-panels v-else focusable class="payout-list">
                <PromoterPayoutPanel class="payout-item" v-for="(payout, index) in payoutList" :key="payout.id"
                    :index="index" :payout="payout" />
            </v-expansion-panels>
        </v-container>
    </v-main>
</template>
  
<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { homeStore } from '@/store/home'
import { promoterPayoutStore } from '@/store/promoter/payout'
import PromoterPayoutPanel from '@/views/promoter/PromoterPayoutPanel.vue'

export default {
    name: 'PromoterPayoutListPage',
    components: { AppbarBackIcon, PromoterPayoutPanel },
    data() {
        return {
            form: {
                status: 'ALL',
                dt_created__lte: null,
            },
            payoutStatusOptionList: [
                {
                    text: '全部',
                    value: 'ALL',
                },
                {
                    text: '待打款',
                    value: 'NOT_DONE',
                },
                {
                    text: '已打款',
                    value: 'DONE',
                },
            ],
            isReady: false,
        }
    },
    computed: {
        payoutList() {
            return promoterPayoutStore.list
        },
        promoter_customer_id() {
            return this.$route.query.promoter_customer_id
        },
        showFilter() {
            return !this.promoter_customer_id
        },
        isEmpty() {
            return this.isReady && this.payoutList.length <= 0
        }
    },
    async mounted() {
        await homeStore.doLoad()
        if (this.promoter_customer_id) {
            await promoterPayoutStore.doLoad({
                promoter_customer_id: this.promoter_customer_id,
            })
            this.isReady = true
            await promoterPayoutStore.doLoadPayoutPromoter(0)
        }
    },
    methods: {
        async onQuery() {
            const doneMap = { DONE: true, NOT_DONE: false, ALL: null }
            let is_done = doneMap[this.form.status]
            let params = {
                is_done: is_done,
                dt_created__lte: this.form.dt_created__lte,
            }
            await promoterPayoutStore.doLoad(params)
            this.isReady = true
        },
    },
}
</script>
  
<style lang="less" scoped>
@import '~@/styles/common';

.content {
    padding-left: 12px;
    padding-right: 12px;
}

.payout-list {
    padding-top: 24px;
    padding-bottom: 16px;
}

.section-header {

    .header-row {
        .header-label {
            margin-right: 8px;
        }

        .header-label,
        .header-value {
            font-weight: bold;
        }
    }
}
</style>
  